/** Legacy strings for الإدارات — Admin/Groups.ar.resx and Resources.ar.resx. */
export const strings = {
  /** سحب الإدارات — `/Groups/Clone`. */
  clone: {
    title: 'سحب الإدارات من مصدر الربط',
    hint: 'إضافة الإدارات الموجودة في مصدر الربط إلى قائمة الإدارات',
    source: 'مصدر الربط',
    sourcePlaceholder: 'اختر مصدر الربط',
    note: 'تتم إضافة الإدارات الجديدة فقط؛ لا يتم حذف أو تعديل أي إدارة موجودة.',
    submit: 'سحب الإدارات',
    running: 'فضلا انتظر',
  },

  /** حذف الإدارات المسحوبة الفارغة — `/Groups/DeleteEmptySyncDepartments`. */
  purge: {
    confirm:
      'سيتم حذف كل إدارة مسحوبة من مصدر الربط لا تحتوي على أي مستخدم. لا يمكن التراجع عن هذه العملية.',
  },

  /* Fallbacks only — the server usually sends its own sentence. */
  actionDone: 'تمت العملية بنجاح',
  actionFailed: 'تعذّر إتمام العملية، فضلا حاول مرة أخرى',
  title: 'الإدارات', // Sitemap.Groups.Title
  subtitle: 'إضافة أو تعديل بيانات إدارة/مجموعة', // Groups.PanelSubHeading
  cardTitle: 'الإدارات/المجموعات', // Groups.PageResource1.Title

  /* The summary strip above the list. Every figure is derived from rows the
     page already has — nothing here asks the API for anything new. */
  stats: {
    caption: 'ملخص الإدارات والمجموعات',
    all: 'كل المجموعات',
    departments: 'إدارات',
    privateGroups: 'مجموعات خاصة',
    members: 'إجمالي المستخدمين',
  },

  columns: {
    index: '#', // Groups.TableHead_1
    name: 'الاسم', // Groups.TableHead_2
    type: 'النوع', // Groups.TableHead_3
    createdOn: 'تاريخ الإنشاء', // Groups.TableHead_4
    usersCount: 'عدد المستخدمين', // Resources.TotalUsers
  },

  actions: {
    add: 'إضافة', // Resources.Add
    createGroup: 'إضافة إدارة/مجموعة جديدة', // Groups.CreateEntryTitle
    update: 'تحديث', // Resources.Update
    syncDepartments: 'سحب وتزامن الإدارات', // Resources.Fetch_and_synchronize + Resources.Departments
    bulkFromExcel: 'تحديث ادارات الموظفين من ملف اكسل', // Resources.Update_employees_departments_from_an_Excel
    /* Both offered only when a departments data source is configured — the payload has
       always said whether one is, and nothing read it. */
    cloneFromDirectory: 'سحب الإدارات من مصدر الربط', // Resources.CloneDepartments
    purgeEmptySynced: 'حذف الإدارات المسحوبة الفارغة',
    deleteEmptySync: 'حذف مجموعات الدليل النشط التي لا تحتوي على مستخدمين', // Resources.Delete_Active_Directory_Groups_With_No_Users
  },

  row: {
    sendEmail: 'إرسال بريد لمجموعة', // Groups.SendEmailModalHeaderTitle
    edit: 'تعديل', // Groups.btnEdit
    users: 'قائمة المستخدمين', // Sitemap.UsersList.Title
    delete: 'حذف', // Groups.btnDelete
  },

  /** #add_modal — one modal for create and edit; the legacy header never changes. */
  form: {
    title: 'إضافة إدارة/مجموعة جديدة', // Groups.CreateEntryTitle
    hint: 'هذه الخاصية تستخدم لإضافة إدارة يدوية، يُفضّل عدم إضافة إدارة إدارية في حال كان النظام متصلًا بمصدر بيانات وتعمل خاصية التزامن أو قد تم سحب الإدارات مسبقًا، ويتم الاكتفاء بإضافة مجموعات خاصة فقط',
    type: 'فئة المجموعة', // Groups.LocGroupType
    arabicName: 'الاسم بالعربية', // Groups.lblArabicResource1.Text
    englishName: 'الاسم بالإنجليزية', // Groups.lblEnglishResource1.Text
    save: 'حفظ', // CertificateSettings.BtnSave
    required: 'الحقل مطلوب', // Users.RequiredFieldValidator_Text
    lengthError: 'المدخل لابد ألا يقل عن 3 أحرف و لا يزيد عن 200', // Users.Regex200_Text
    createdMessage: 'تم إضافة الإدارة بنجاح',
    updatedMessage: 'تم تحديث بيانات الإدارة بنجاح',
  },

  /** #users_modal */
  usersModal: {
    title: 'قائمة المستخدمين', // Sitemap.UsersList_Title
    hint: 'إذا كنت تريد إزالة المستخدمين من المجموعة ، فما عليك سوى الاختيار من الجدول والنقر فوق إزالة المستخدمين',
    columns: {
      index: 'م',
      userName: 'اسم المستخدم',
      name: 'الاسم الكامل',
      email: 'البريد الإلكتروني',
      status: 'الحاله', // Resources.Status
    },
    removeUsers: 'حذف المستخدمين', // Users.DeleteButtonResource1.Text
    addUsers: 'إضافة مستخدمين', // Resources.Add_Users
    exportExcel: 'تصدير إلى أكسل',
    exportPdf: 'تصدير إلى PDF',
  },

  /** #add_users_modal */
  addUsersModal: {
    title: 'مجموعات خاصة', // UsersGroups.PageResource1.Title
    tabs: {
      list: 'قائمة المستخدمين', // Users.PageResource1.Title
      excel: 'رفع ملف إكسل', // Groups.Execl_Upload
    },
    hint: 'إذا كنت ترغب في إضافة مستخدمين إلى المجموعة ، فما عليك سوى الاختيار من الجدول والنقر فوق حفظ',
    groupLabel: 'الإدارات:', // Resources.Groups
    groupPlaceholder: 'الإدارة',
    columns: {
      index: 'م',
      userName: 'اسم المستخدم',
      nameAr: 'الاسم بالعربية',
      nameEn: 'الاسم بالإنجليزية',
      email: 'البريد الإلكتروني',
      // The server fills this column from LoginProvider, not the department
      // (DataTablesManager.cs:107). Header and key are paired as in the legacy.
      group: 'الإدارة',
    },
    save: 'حفظ', // CertificateSettings.BtnSave
    nothingSelected: 'لم يتم تحديد أي مستخدمين من الجدول أو إضافتهم في ملف الإكسل.', // Resources.noUsersSelectedOrAddedOnExcel
  },

  /** #sendEmail_modal */
  emailModal: {
    title: 'إرسال بريد لمجموعة', // Groups.SendEmailModalHeaderTitle
    messageTitle: 'عنوان الرسالة', // NotificationSettings.TxtMessageTitle
    sendDate: 'تاريخ الإرسال', // UserDetailsAdmin.LblSendDate
    messageBody: 'نص الرسالة', // UserDetailsAdmin.LblMessageBody
    previousNotifications: 'التنبيهات السابقة', // Resources.PreviousNotifications
    submit: 'جدولة الإرسال', // Groups.SendEmailActionButton
    missingTitle: 'عنوان الرسالة مطلوب', // UserDetailsAdmin.MissingMessageTitle
    missingSendTime: 'تاريخ الإرسال مطلوب', // UserDetailsAdmin.MissingSendTime
    missingBody: 'نص الرسالة مطلوب', // UserDetailsAdmin.MissingMessageBody
    success: 'تم بنجاح', // CoursesManagement.SuccessMessage
    datePlaceholder: 'ex. 2020-10-01 17:00',
  },

  /** #bulk_modal */
  bulkModal: {
    title: 'تحديث ادارات الموظفين من ملف اكسل', // Resources.Update_employees_departments_from_an_Excel
    hint: 'تُستخدم هذه الخاصية لتحديث إدارة الموظفين في حال لم تكن خاصية التزامن تعمل، أو لم يكن مصدر الربط محدثاً ولا يحتوي على إدارات كاملة وتم إدخال الإدارات بشكل يدوي. (يستخدم لتحديث المجموعات من النوع الإداري فقط)',
    submit: 'تحديث', // Groups.Update
    missingFile: 'يرجى ملء ملف Excel الخاص بالمستخدم ثم تحميله مرة أخرى', // Groups.Please_fill_user_excel_file_then_upload_it_again
    success: 'تم بنجاح',
  },

  /** Shared excel-upload copy. */
  excel: {
    intro: 'يُرجى رفع ملف بصيغة Excel (.xlsx) أو CSV (.csv)', // Resources.Please_upload_a_file_in_Excel
    introXlsxOnly: 'يُرجى رفع ملف بصيغة Excel (.xlsx)', // Resources.Please_upload_a_file_in_Excel_only
    columnsIntro: 'يجب أن يحتوي الملف على الأعمدة التالية',
    mandatory: 'إجباري', // Resources.Mandatory
    optional: 'إختياري', // Resources.Optional
    notesTitle: 'ملاحظات مهمة', // Resources.Important_Notes
    notes:
      'يجب أن يحتوي الصف الأول في الملف على أسماء الأعمدة، وبنفس الأسماء والترتيب الموضح في الجدول',
    template: 'معاينة القالب', // Resources.ViewTemplate
  },

  deleteConfirm: 'هل تريد حذف هذه الإداره؟', // Groups.Do_you_really_want_to_delete_this_group_
  close: 'إغلاق', // Groups.btnClose
}
